import { render } from "./AssignProducts.vue?vue&type=template&id=02ed7fd5&scoped=true&ts=true"
import script from "./AssignProducts.vue?vue&type=script&lang=ts"
export * from "./AssignProducts.vue?vue&type=script&lang=ts"

import "./AssignProducts.vue?vue&type=style&index=0&id=02ed7fd5&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ed7fd5"]])

export default __exports__